<template>
	<div class="v-menu-container">
		<div v-if="$slots['header']" class="v-menu-header">
			<slot name="header" />
		</div>
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * Vertical menu is used in slide outs to list all the possible menu items.
 */
export default defineComponent({
	name: "VerticalMenu"
});
</script>
<style lang="scss">
$menu-height: 60px;
.v-menu-container {
	display: flex;
	flex-direction: column;
	padding-bottom: 24px;
	> .v-menu-header {
		padding-left: 24px;
		padding-right: 24px;
		padding-top: 24px;
	}
	> .slab-hierarchy > .slab-container {
		min-height: $menu-height;
	}
}
</style>
